import { Info } from './components/Info';
const InfoMapLayer = ({
  typeInfo,
  cardInfo,
  locationInfo,
  vehicleInfo,
  infoBarVisible,
  adress,
  adressLoading,
  setInfoBarVisible,
  seatInfo,
  beltInfo,
}) => {
  return (
    <>
      {infoBarVisible ? (
        <div className={` md:flex sm:hidden items-center px-2 justify-center `}>
          <Info
            typeInfo={typeInfo}
            cardInfo={cardInfo}
            locationInfo={locationInfo}
            adress={adress}
            setInfoBarVisible={setInfoBarVisible}
            adressLoading={adressLoading}
            vehicleInfo={vehicleInfo}
            seatInfo={seatInfo}
            beltInfo={beltInfo}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default InfoMapLayer;
